import { connect } from 'react-redux';
import DataCollection from './DataCollection';
import { STATE_ROOT } from '../../../../redux';

const mapStateToProps = state => ({
  app: state[STATE_ROOT].apps.details.settings.settings,
});

export default connect(mapStateToProps, null)(DataCollection);
